export default __webpack_public_path__ + "static/media/card_back.2aec3e61.png";